var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44681 0.678826C9.72804 0.441348 10.1374 0.441348 10.4186 0.678826L18.6679 7.67819C18.9834 7.94692 19.0241 8.41875 18.7553 8.73435C18.4866 9.04994 18.0148 9.08744 17.6992 8.82184L16.9305 8.1719V13.9995C16.9305 15.3806 15.8119 16.4993 14.4307 16.4993H5.43155C4.05043 16.4993 2.93178 15.3806 2.93178 13.9995V8.1719L2.16622 8.82184C1.85063 9.09056 1.37567 9.04994 1.11007 8.73435C0.844468 8.41875 0.881964 7.94379 1.19756 7.67819L9.44681 0.678826ZM9.93115 2.23494L4.43164 6.90014V13.9995C4.43164 14.5526 4.87848 14.9994 5.43155 14.9994H6.93142V10.2498C6.93142 9.55927 7.49074 8.99995 8.1813 8.99995H11.681C12.3716 8.99995 12.9309 9.55927 12.9309 10.2498V14.9994H14.4307C14.9838 14.9994 15.4306 14.5526 15.4306 13.9995V6.90014L9.93115 2.23494ZM8.43128 14.9994H11.431V10.4998H8.43128V14.9994Z",
    fill: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressQuestion);
export default __webpack_public_path__ + "static/media/address-question.a1c0fdaffcaf1364bc1fa72d0cfa10df.svg";
export { ForwardRef as ReactComponent };